import { RequestConfig } from '@bigo/yapi-to-ts';

import { useRequest, UseRequestOptions } from '@/compositions/useRequest';

import baseRequest, { FormatedData } from './request';

export default function makeRequestHook<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult extends ReturnType<typeof baseRequest>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
>(request: any) {
  type Data = TRequestResult extends Promise<infer R> ? R : TRequestResult;

  type ReqData = TRequestConfig['requestDataOptional'] extends true
    ? [TRequestData?]
    : [TRequestData];

  return (arg?: Partial<UseRequestOptions<Data['data'], ReqData>>) => {
    const overwriteOpt = {
      formatResult: (res: FormatedData<Data['data']>) => {
        if (!res.error) {
          return res.data;
        }
        // eslint-disable-next-line no-throw-literal
        throw { type: 'CUSTOM_ERROR', error: res.error };
      },
    };
    const options = arg
      ? {
          ...arg,
          ...overwriteOpt,
        }
      : { ...overwriteOpt };
    return useRequest<Data['data'], ReqData>(request, options);
  };
}
